import React, { useCallback, useEffect, useState } from 'react';

import { ActionButton } from '~/components/partials/ReceptionDrawer/ActionButton';
import { LineVisitorAppointmentDetailFragment } from '~/graphql/generated/graphql';
import { openPreviewPage } from '~/utils/prescription';

type Props = {
  appointment: LineVisitorAppointmentDetailFragment;
};

export const PendingButtons = React.memo((props: Props) => {
  const { appointment } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(() => {
    setIsLoading(true);

    openPreviewPage(appointment.id, true);
  }, [appointment.id]);

  useEffect(() => {
    let timerId: number | undefined = undefined;

    if (isLoading) {
      // ウィンドウ起動中であることが視覚的にわかるように一定時間おく
      timerId = window.setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [isLoading]);

  return (
    <ActionButton use="primary" wide="fill" size="l" loading={isLoading} onClick={handleClick}>
      処方箋を確認
    </ActionButton>
  );
});

PendingButtons.displayName = 'PendingButtons';
